import currency from 'currency.js';
import { itemTotalPrice } from './itemPrice';

export const bundlePrice = (
  { price, items = [], hasEatInPrice, priceEatIn },
  isTakeAway: boolean,
  displayCheapestFromPrice?: boolean
) => {
  const itemsPrice = items.reduce((acc, item) => {
    const itemPrice = itemTotalPrice(item, isTakeAway, displayCheapestFromPrice);
    return acc.add(itemPrice);
  }, currency(0));
  const bundlePrice = hasEatInPrice && !isTakeAway ? priceEatIn : price;

  return currency(bundlePrice).add(itemsPrice).value;
};
